import { useEffect, useRef, useCallback } from 'react';
import { useMusic } from '../../contexts/MusicContext';
//@ts-ignore
import music from './Assets/Ambient.mp3';

const Music: React.FC = () => {
  const { isPlaying, setIsPlaying, currentTime, setCurrentTime } = useMusic();
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const fadeInterval = useRef<NodeJS.Timeout>();
  const timeInterval = useRef<NodeJS.Timeout>();

  const handlePlay = useCallback(() => {
    setIsPlaying(true);
  }, [setIsPlaying]);

  const handlePause = useCallback(() => {
    setIsPlaying(false);
  }, [setIsPlaying]);

  const fadeAudio = useCallback((fadeIn: boolean) => {
    if (audioRef.current) {
      clearInterval(fadeInterval.current);
      const audio = audioRef.current;
      
      if (fadeIn && audio.paused) {
        audio.volume = 0;
        audio.currentTime = currentTime;
        setTimeout(() => {
          audio.play().catch(() => {
            setIsPlaying(false);
          });
          fadeInterval.current = setInterval(() => {
            if (audio.volume < 0.2) {
              audio.volume = Math.min(audio.volume + 0.02, 0.2);
            } else {
              clearInterval(fadeInterval.current);
            }
          }, 50);
        }, 350);
      } else if (!fadeIn) {
        fadeInterval.current = setInterval(() => {
          if (audio.volume > 0.02) {
            audio.volume = Math.max(audio.volume - 0.02, 0);
          } else {
            audio.pause();
            audio.volume = 0;
            clearInterval(fadeInterval.current);
          }
        }, 50);
      }
    }
  }, [currentTime, setIsPlaying]);

  // Add beforeunload event listener to handle page transitions
  useEffect(() => {
    const handleBeforeUnload = () => {
      if (audioRef.current && !audioRef.current.paused) {
        // Store current time in localStorage before unload
        localStorage.setItem('musicTime', audioRef.current.currentTime.toString());
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.loop = true;
      
      audioRef.current.addEventListener('play', handlePlay);
      audioRef.current.addEventListener('pause', handlePause);
    }

    timeInterval.current = setInterval(() => {
      if (audioRef.current && !audioRef.current.paused) {
        setCurrentTime(audioRef.current.currentTime);
      }
    }, 1000);

    return () => {
      if (audioRef.current) {
        audioRef.current.removeEventListener('play', handlePlay);
        audioRef.current.removeEventListener('pause', handlePause);
      }
      clearInterval(timeInterval.current);
      clearInterval(fadeInterval.current);
    };
  }, [handlePlay, handlePause]);

  useEffect(() => {
    fadeAudio(isPlaying);

    return () => {
      clearInterval(fadeInterval.current);
    };
  }, [isPlaying]);

  return (
    <div className="music-player">
      <audio ref={audioRef} src={music} />
    </div>
  );
};

export default Music;
